module.exports = __webpack_public_path__ + "static/media/info-warning.33aab54e.svg";